<div class="flex flex-row justify-center items-center content-center" class="profile-container">
  <div class="basis-5/12 xs:basis-9/12 profile-wrapper">
    <span class="close" (click)="close()"><mat-icon>close</mat-icon></span>
    <div class="flex flex-col justify-center items-center content-center" class="margin-right-20">
      <img class="logo" src="../../../../assets/images/logo-img.svg" />
      <h1 mat-dialog-title translate>Bewerk gegevens</h1>
      <p>Wijzig hier je persoonlijke gegevens</p>
    </div>
    <form [formGroup]="profileForm" autocomplete="on">
      <div class="flex flex-col">
        <div class="flex flex-row">
          <mat-radio-group aria-label="Geslacht" formControlName="gender" id="gender">
            <mat-radio-button value="M">Man</mat-radio-button>
            <mat-radio-button value="V">Vrouw</mat-radio-button>
          </mat-radio-group>
          <mat-error>
            <div *ngIf="gender.invalid && gender.errors.required">Geslacht is verplicht</div>
          </mat-error>
        </div>
        <mat-form-field appearance="fill">
          <mat-label>Voornaam</mat-label>
          <input matInput placeholder="Voornaam" formControlName="firstName" id="firstName" autocomplete="given-name">
          <mat-error *ngIf="firstName.invalid && firstName.errors.required">Voornaam is verplicht</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Achternaam</mat-label>
          <input matInput placeholder="Achternaam" formControlName="lastName" id="lastName" autocomplete="family-name">
          <mat-error *ngIf="lastName.invalid && lastName.errors.required">Achternaam is verplicht</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Geboortedatum</mat-label>
          <input matInput type="date" placeholder="Geboortedatum" formControlName="dateOfBirth" id="dateOfBirth" autocomplete="bday">
          <mat-error *ngIf="dateOfBirth.invalid && dateOfBirth.errors.required">Geboortedatum is verplicht</mat-error>
        </mat-form-field>
        <mat-checkbox color="primary" formControlName="optIn" id="optIn">Houd mij op de hoogte van nieuwe aanbiedingen!</mat-checkbox>
      </div>
    </form>
    <div class="flex flex-row justify-center items-center content-center" class="mt-4">
      <button mat-raised-button color="accent" (click)="updateProfile()">Opslaan</button>
    </div>
  </div>
</div>
